import { canAccessOtCosting } from './otCostingAccess';

const WELFARE_OPEN_DEPTS = new Set(['IT Development', 'ทรัพยากรบุคคล']);

/** แผนก HR / IT Dev เข้าได้ทุก rank; แผนกอื่นใช้เกณฑ์เดียวกับ OT (Manager ขึ้นไป) */
export function canAccessManageWelfare(emp) {
  if (!emp) return false;
  const dept = emp?.organization?.level5;
  if (dept && WELFARE_OPEN_DEPTS.has(dept)) return true;
  return canAccessOtCosting(emp);
}
